import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Txt,
  View,
  TenantDepositDetails,
} from 'components';
import { useState } from 'react';
import { paymentTypes } from 'config/types';
import { formatCurrency } from 'helpers/formatNumber';
import { useDataActions, useTenancy } from 'state';
import styles from './OrdersNotSetup.module.scss';

/**
 * OrdersNotSetup
 *
 * @return {JSX.Element}
 */
const OrdersNotSetup = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageActions = useDataActions();
  const tenancyDoc = useTenancy();
  const { tenants: tenantsCollection } = tenancyDoc;

  const tenancyData = tenancyDoc.data;
  const tenantsData = tenantsCollection.data;

  const handleSendStandingOrderReminder = () => {
    setIsLoading(true);
    storageActions.tenancy
      .sendDepositReminder(tenancyDoc, paymentTypes.RENT)
      .finally(() => setIsLoading(false));
  };

  return (
    <FlexContainer
      className={classNames(
        styles.OrdersNotSetup,
        className,
        OrdersNotSetup.displayName
      )}
      column
      gap
    >
      <Txt bold>⚠️ Awaiting tenant setup</Txt>
      <View>
        <Txt xxx bold>
          £{formatCurrency(tenancyData.payments.standingOrderAmount)}
        </Txt>
        <Txt caption>/£{formatCurrency(tenancyData.payments.rentAmount)}</Txt>
      </View>
      <FlexContainer column gapHalf>
        {tenantsData.map((t) => {
          return (
            <TenantDepositDetails
              key={t.id}
              fullName={t.data.fullName}
              actionLabel={
                t.data.payments?.standingOrderPlaidUid ? 'PAID' : 'DUE'
              }
              emailAddress={t.data.emailAddress}
              mobileNumber={t.data.mobileNumber}
              isDone={t.data.payments?.standingOrderPlaidUid}
            />
          );
        })}
      </FlexContainer>
      <Txt regular>
        A standing order is a no fee way of receiving rent from your tenants. A
        tenant has to set this payment up with their bank.
      </Txt>
      <Txt regular>
        Propa with its partner Plaid (Plaid Financial Ltd) makes it easy for
        your tenants to pay their rent directly to your linked bank account.
      </Txt>
      <Txt regular>
        Payments are processed on the first day of the tenancy and each month
        thereafter.
      </Txt>
      <Button
        success
        onClick={handleSendStandingOrderReminder}
        disabled={isLoading}
      >
        Send Standing Order Reminder
      </Button>
    </FlexContainer>
  );
};

OrdersNotSetup.displayName = 'OrdersNotSetup';

export default OrdersNotSetup;
